import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "mr-0.5 font-mono" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.healthScore.score !== null)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["inline-flex items-center gap-2 rounded-full px-2 py-1 text-xs font-semibold", $setup.scoreColor($props.healthScore.score)]),
        title: "Health score do relacionamento"
      }, [
        _createElementVNode("img", {
          src: $setup.ActivityIcon,
          class: "mr-0 h-3 w-3"
        }, null, 8 /* PROPS */, _hoisted_1),
        _createElementVNode("span", _hoisted_2, _toDisplayString($props.healthScore.score), 1 /* TEXT */),
        _createTextVNode(" " + _toDisplayString($setup.status ? _ctx.$t('contact.timeline.stats.healthScore.' + $setup.status) : '-'), 1 /* TEXT */)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}